// Custom Accordion JavaScript with ARIA support
document.addEventListener('DOMContentLoaded', function() {
    // Find all accordion headers
    const accordionHeaders = document.querySelectorAll('.accordion-header');
    
    // Setup ARIA attributes for accessibility
    accordionHeaders.forEach((header, index) => {
        // Add button role and attributes
        header.setAttribute('role', 'button');
        header.setAttribute('aria-expanded', 'false');
        
        const content = header.nextElementSibling;
        const contentId = `accordion-content-${index}`;
        content.setAttribute('id', contentId);
        header.setAttribute('aria-controls', contentId);
        
        // Make header focusable
        header.setAttribute('tabindex', '0');
        
        // Handle keyboard access
        header.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
            }
        });
          // Attach click event listener to each header
        header.addEventListener('click', function() {
            // Toggle active class on the header
            this.classList.toggle('active');
            
            // Find the content element that follows this header
            const content = this.nextElementSibling;
            
            // Toggle the active class on content and update ARIA attributes
            content.classList.toggle('active');
            
            // Update ARIA expanded state
            if (content.classList.contains('active')) {
                this.setAttribute('aria-expanded', 'true');
            } else {
                this.setAttribute('aria-expanded', 'false');
            }
        });
    });

    // Initialize accordions - setup ARIA attributes
    const accordionContents = document.querySelectorAll('.accordion-content');
    accordionContents.forEach(content => {
        content.setAttribute('role', 'region');
    });

    console.log('Accessible accordion script loaded and initialized!');
});
